import { createSelector } from '@reduxjs/toolkit'

const cartQuantity = state => state.cart.cartQuantity
const cartItems = state => state.cart.entities.items
const cartItemIds = state => state.cart.result
const cartSettings = state => state.cart.settings
const orderTotals = state => state.cart.orderTotals
const appliedDiscounts = state => state.cart.misc.appliedDiscounts
const appliedGiftCards = state => state.cart.misc.appliedGiftCards
const checkoutAttributes = state => state.cart.checkoutAttributes

export const cartSelector = createSelector(
	cartItems,
	cartItemIds,
	cartSettings,
	orderTotals,
	appliedDiscounts,
	appliedGiftCards,
	checkoutAttributes,
	(
		products,
		ids,
		settings,
		orderTotals,
		appliedDiscounts,
		appliedGiftCards,
		checkoutAttributes,
	) => {
		const items = ids.map(id => products[id])
		// .sort((a, b) => a.sku.localeCompare(b.sku))

		let quantity = 0

		items.forEach(item => {
			if (item && item.quantity) quantity += item.quantity
		})

		return {
			cartQuantity: quantity,
			items,
			ids,
			settings,
			orderTotals,
			appliedDiscounts,
			appliedGiftCards,
			checkoutAttributes,
		}
	},
)
